import { Checkbox, Typography } from '@neo4j-ndl/react';
import { REGIONAL_GDPR_COMPLIANCE_TIER } from '@nx/state';

type MarketingOptInProps = {
  regionalTier: REGIONAL_GDPR_COMPLIANCE_TIER;
  marketingPreference: boolean;
  onChange: () => void;
};

export const MarketingOptIn = ({ regionalTier, marketingPreference, onChange }: MarketingOptInProps) => {
  const checkboxLabel = {
    [REGIONAL_GDPR_COMPLIANCE_TIER.TIER_2]: (
      <Typography variant="body-medium">
        I want to opt <span className="underline">out</span> of emails about products, services, and events.
      </Typography>
    ),
    [REGIONAL_GDPR_COMPLIANCE_TIER.TIER_3]: (
      <Typography variant="body-medium">I want to opt in to emails about products, services, and events.</Typography>
    ),
  };

  const checkboxAriaLabel = {
    [REGIONAL_GDPR_COMPLIANCE_TIER.TIER_2]: 'I want to opt out of emails about products, services, and events.',
    [REGIONAL_GDPR_COMPLIANCE_TIER.TIER_3]: 'I want to opt in to emails about products, services, and events.',
  };

  return (
    <div className="flex flex-col justify-between gap-4" data-testid="marketing-consent-section">
      {regionalTier !== REGIONAL_GDPR_COMPLIANCE_TIER.TIER_1 ? (
        <Checkbox
          isChecked={marketingPreference}
          onChange={onChange}
          ariaLabel={checkboxAriaLabel[regionalTier]}
          label={checkboxLabel[regionalTier]}
          htmlAttributes={{
            'data-testid': 'marketing-consent-checkbox',
          }}
        />
      ) : (
        <Typography variant="body-medium">
          We will send occasional emails about products, services, and events. You can unsubscribe at any time.
        </Typography>
      )}
    </div>
  );
};
